/**
 * Generic reveals, declared in the markup with [data-reveal]:
 *   up    rises into place
 *   clip  unveils from the top
 * The start states live in utilities/_motion.scss.
 *
 * @module motion/reveals
 */

import { REDUCED_MOTION } from '../config.js';
import { $$ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';

export function animateReveals() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('[data-reveal]').forEach((element) => {
        const scrollTrigger = { trigger: element, start: 'top 90%', once: true };

        if (element.dataset.reveal === 'up') {
            gsap.to(element, { opacity: 1, y: 0, duration: 1.05, scrollTrigger });
        } else if (element.dataset.reveal === 'clip') {
            gsap.to(element, { clipPath: 'inset(0 0 0% 0)', duration: 1.2, scrollTrigger });
        }
    });
}
